import { Text } from 'common-components'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const MusicVersioningContainer = styled.div`
  height: 100%;

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    padding-bottom: 40px;
  }
`

export const MusicVersioningOverlayTitle = styled(Text)`
  font-weight: 600;
  padding-left: 16px;
`

export const DivideLine = styled.div`
  height: 1px;
  width: 100%;
  background: ${COLORS.borderColor};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`
